import client from '../client';

const PATH = '/matching-items';

/**
 * Get the MatchingItems that matches with the given options.
 * To see more information about this endpoints please see the endpoint's docs in the matcher-api.
 * @param {Object} payload
 * @param {String[]} payload.brands
 * @param {Number} payload.classificationId
 * @param {Number} payload.featureId
 * @param {String} payload.likePattern
 * @param {String} payload.notLikePattern
 * @param {Boolean} payload.onlyMissing
 * @param {Number} payload.offset
 * @param {Number} payload.fetch
 */
function getByRule(params) {
  return client.get(`${PATH}-by-rule`, { params }).then(({ data }) => data)
}

export default {
  getByRule
}